const getCssClassName = (string, alignment) => {
  if (alignment) string += `--${alignment}`
  return string.replace(/ /g, "").replace(/'/g, "").toLowerCase()
}
export default getCssClassName
